import { render, staticRenderFns } from "./DispatchToSiteBatch.vue?vue&type=template&id=18092d6c"
import script from "./DispatchToSiteBatch.vue?vue&type=script&lang=ts"
export * from "./DispatchToSiteBatch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports